import {Button, Form, InputGroup} from "react-bootstrap";
import React from "react";
import {YaPaginationSizeInterface} from "./YaPaginationSizeInterface";
import styles from "./YaPagination.module.css";

export const YaPaginationSize = (props: YaPaginationSizeInterface) => {
    const onPageSizeChange = (value: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const parsedValue = parseInt(value.target.value);
        if (isNaN(parsedValue) || parsedValue < 0) {
            props.updatePageSize(0);
            return;
        }
        if (parseInt(value.target.value) > props.maxPageSize) {
            props.updatePageSize(props.maxPageSize);
            return;
        }
        props.updatePageSize(parseInt(value.target.value));
    }
    return (
            <InputGroup size="sm">
                <Button
                    onClick={() => props.updatePageSize(props.pageSize <= 1 ? 1 : props.pageSize - 1)}>
                    -
                </Button>
                <Form.Control
                    min={1}
                    max={10}
                    className={styles.pagingText}
                    type="text"
                    value={props.pageSize}
                    onChange={onPageSizeChange}
                />
                <Button
                    className={styles.e}
                    onClick={() => props.updatePageSize(props.pageSize >= 99 ? props.maxPageSize : props.pageSize + 1)}>
                    +
                </Button>
                <Button
                    className={styles.pagingRefreshButton}
                    onClick={async () => await props.applyPageSizeChange()}>
                    Refresh
                </Button>
            </InputGroup>
    )
}
